import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-88ec1922"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "information"
};
var _hoisted_2 = {
  "class": "list"
};
var _hoisted_3 = {
  "class": "list-inner"
};
var _hoisted_4 = {
  "class": "name"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "arrow"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "icon"
  })], -1);
});
import { useQuestion } from '@/hooks/useQuestion';
import { computed, ref } from 'vue';
import { ErrorCode } from '@/types';
import { t } from '@/lang';
import DTitle from '@/components/DTitle.vue';
import { getInformationItem, getInformationType } from '@/utils/information';
import { nodeList } from '@/utils/answer';
export default /*#__PURE__*/_defineComponent({
  __name: 'InformationCollection',
  setup: function setup(__props, _ref) {
    var _content$information;
    var __expose = _ref.expose;
    var _useQuestion = useQuestion(),
      content = _useQuestion.content,
      question_id = _useQuestion.question_id;
    var information = content.information;
    var showPicker = ref(false);
    var choice = ref({});
    var node = nodeList.find(question_id);
    var otherLabel = t().A17();
    var placeholder = computed(function () {
      return t().A25();
    });
    var answers = {};
    if (node) {
      try {
        answers = JSON.parse(node.value.answer);
      } catch (_unused) {
        answers = {};
      }
    }
    (_content$information = content.information) === null || _content$information === void 0 || _content$information.forEach(function (item) {
      var key = item.key;
      var answer = answers[key];
      if (answer) {
        var other = false;
        if (item.options && item.options.length) {
          other = item.options.findIndex(function (option) {
            return option === answer;
          }) === -1;
        }
        choice.value[key] = {
          isOther: other,
          value: answer
        };
      } else {
        choice.value[key] = {
          isOther: false,
          value: ''
        };
      }
    });
    var columns = ref([]);
    var type = computed(function () {
      var _information$;
      return getInformationType(information === null || information === void 0 || (_information$ = information[0]) === null || _information$ === void 0 ? void 0 : _information$.key);
    });
    var cancelButtonText = computed(function () {
      return t().A21();
    });
    var confirmButtonText = computed(function () {
      return t().A20();
    });
    var showOther = function showOther(key) {
      var _choice$value$key;
      var isOther = !!((_choice$value$key = choice.value[key]) !== null && _choice$value$key !== void 0 && _choice$value$key.isOther);
      return isOther;
    };
    var showLabel = function showLabel(key) {
      var _choice$value$key2;
      var isOther = showOther(key);
      if (isOther) {
        return otherLabel;
      }
      return ((_choice$value$key2 = choice.value[key]) === null || _choice$value$key2 === void 0 ? void 0 : _choice$value$key2.value) || '';
    };
    var list = computed(function () {
      if (!information || !information.length) return [];
      return information.map(function (item) {
        var _item$options = item.options,
          options = _item$options === void 0 ? [] : _item$options;
        return _objectSpread(_objectSpread({}, item), {}, {
          name: t().B(item.key),
          options: options.map(function (option, index) {
            return {
              label: option,
              position_id: index + 1
            };
          })
        });
      });
    });
    var currentIndex = ref(0);
    var onShow = function onShow(item, index) {
      if (type.value === 'input') {
        return;
      }
      currentIndex.value = index;
      columns.value = item.options.map(function (option) {
        return {
          text: option.label,
          value: option.label
        };
      });
      var info = getInformationItem(item.key);
      // 判断有没有other
      if (info !== null && info !== void 0 && info.other) {
        columns.value.push({
          text: otherLabel,
          value: otherLabel
        });
      }
      showPicker.value = true;
    };
    var onConfirm = function onConfirm(data) {
      var _data$selectedValues = data.selectedValues,
        selectedValues = _data$selectedValues === void 0 ? [] : _data$selectedValues;
      var key = list.value[currentIndex.value].key;
      var value = selectedValues[0];
      if (value === otherLabel) {
        choice.value[key] = {
          isOther: true,
          value: ''
        };
      } else {
        choice.value[key] = {
          isOther: false,
          value: value
        };
      }
      // 插入数组指定下标
      showPicker.value = false;
      columns.value = [];
    };
    var getAnswer = function getAnswer() {
      var _list$value;
      var answer = {};
      (_list$value = list.value) === null || _list$value === void 0 || _list$value.forEach(function (item) {
        var _choice$value$item$ke;
        answer[item.key] = (_choice$value$item$ke = choice.value[item.key]) === null || _choice$value$item$ke === void 0 ? void 0 : _choice$value$item$ke.value;
      });
      return answer;
    };
    __expose({
      validate: function () {
        var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _list$value2;
          var ok;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                debugger;
                ok = true;
                (_list$value2 = list.value) === null || _list$value2 === void 0 || _list$value2.forEach(function (item) {
                  var _choice$value$item$ke2;
                  if (item.required && !((_choice$value$item$ke2 = choice.value[item.key]) !== null && _choice$value$item$ke2 !== void 0 && _choice$value$item$ke2.value)) {
                    ok = false;
                  }
                });
                if (ok) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return", {
                  status: false,
                  code: ErrorCode.Necessary
                });
              case 5:
                return _context.abrupt("return", {
                  status: true,
                  data: {
                    question_id: question_id,
                    position: [],
                    answer: JSON.stringify(getAnswer())
                  }
                });
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function validate() {
          return _validate.apply(this, arguments);
        }
        return validate;
      }()
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_picker = _resolveComponent("van-picker");
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(DTitle), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": "item"
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
          "class": _normalizeClass({
            necessary: item.required
          })
        }, _toDisplayString(item.name), 3)]), type.value === 'select' ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "class": "select",
          onClick: _withModifiers(function ($event) {
            return onShow(item, index);
          }, ["stop"])
        }, [_createTextVNode(_toDisplayString(showLabel(item.key)) + " ", 1), _hoisted_6], 8, _hoisted_5)) : _createCommentVNode("", true), choice.value[item.key] && type.value === 'input' ? (_openBlock(), _createBlock(_component_van_field, {
          key: 1,
          modelValue: choice.value[item.key].value,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return choice.value[item.key].value = $event;
          },
          placeholder: placeholder.value,
          "class": "other key-input"
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : _createCommentVNode("", true), choice.value[item.key] && type.value === 'select' && showOther(item.key) ? (_openBlock(), _createBlock(_component_van_field, {
          key: 2,
          modelValue: choice.value[item.key].value,
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return choice.value[item.key].value = $event;
          },
          "class": "other key-input",
          placeholder: placeholder.value,
          style: {
            "margin-top": "15px"
          }
        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : _createCommentVNode("", true)]);
      }), 128))])]), _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return showPicker.value = $event;
        }),
        position: "bottom"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_van_picker, {
            columns: columns.value,
            "cancel-button-text": cancelButtonText.value,
            "confirm-button-text": confirmButtonText.value,
            onConfirm: onConfirm,
            onCancel: _cache[0] || (_cache[0] = function ($event) {
              return showPicker.value = false;
            })
          }, null, 8, ["columns", "cancel-button-text", "confirm-button-text"])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});